import React from "react";
import ValueLabelDisplay from "../../../../../../organisms/ValueLabelDisplay";
import moment from "moment/moment";

const View = ({ data }) => {
  return (
    <>
      <ValueLabelDisplay label="User Name">{data?.name}</ValueLabelDisplay>
      <ValueLabelDisplay label="Email Id">
        {data?.email}
      </ValueLabelDisplay>
      <ValueLabelDisplay label="Phone No">{data?.phone}</ValueLabelDisplay>
      <ValueLabelDisplay label="Country">{data?.country}</ValueLabelDisplay>
      <ValueLabelDisplay label="Business Name">{data?.business_name}</ValueLabelDisplay>
      <ValueLabelDisplay label="Business Type">{data?.business_type}</ValueLabelDisplay>
      <ValueLabelDisplay label="Description">
        {data?.content}
      </ValueLabelDisplay>
      <ValueLabelDisplay label="Created Date">
        {data?.created_date
          ? moment(data.requested_at).format("YYYY-MM-DD, h:mm A")
          : "N/A"}
      </ValueLabelDisplay>
    </>
  );
};

export default View;